import { Injectable } from "@angular/core";
import { Response, Headers, Http } from "@angular/http";

import { Observable } from "rxjs/Observable";
import { Angular2TokenService } from "angular2-token";

import { User } from "./user.model";

@Injectable()
export class AuthService {

  //public tasksUrl = 'http://localhost/my.api.com.br/user/adduser';
  public tasksUrl = 'http://www.agenciasnet.com.br/api/adduser';
  //HEADER PARA AS REQUISIÇÕES DELETE, CREAT E UPDATE
  //public headers = new Headers({'Content-Type': 'application/json'});
  public headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'});

  //let headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' });
  //let options = new RequestOptions( {method: RequestMethod.Post, headers: headers });

  public constructor(private http: Http, private tokenService: Angular2TokenService) {}

  /**
     * signUp
     *      
    */
  public signUp(user: User): Observable<Response> {
    //call Angular2-Token SignUp method here
    //return a Observable<Response>

    return this.tokenService.registerAccount(user as any)
      .catch(this.handleErrors);
  }

  /**
    * createTask
    * MÉTODO RESPONSÁVEL POR CRIAR UMA TAREFA
    */
   public create(user: User): Observable<User> {
    let url  = this.tasksUrl;
    //let body2 = JSON.stringify(user);

    var obj = { name: user.name, email: user.email, password: user.password };

    let body = this.serializeObj(obj);
    
    console.log("SERIALIZADO: "+body);

    return this.http.post(url, body, {headers: this.headers, method: "POST"})
           .catch(this.handleErrors)
           .map(response => response.json().data as User);

  }


/**
 * MÉTODO RESPONSÁVEL PARA TRANFORMAR UM OBJETO LEGIVEL PARA A API RECEBER OS PARAMETROS
 * @param obj 
 */
private serializeObj(obj) {
    var result = [];
    for (var property in obj)
        result.push(encodeURIComponent(property) + "=" + encodeURIComponent(obj[property]));

    return result.join("&");
}

  /**
     * signIn
     *      
    */
  public signIn(uid: string, password: string) {
    //call Angular2-Token signIn method here
    //return a Observable<Response>
  }

  /**
     * signOut
     *      
    */
  public signOut() {
    //call Angular2-Token signOut method here
    //return a Observable<Response>
  }

  /**
     * isIsgnedIn
     *      
    */
  public userSignedIn() {
    //call Angular2-Token userSignedIn method here
    //return a Boolean
    return true;
    //return this.tokenService.userSignedIn();
  }

  //MÉTODO RESPONSÁVEL PARA TRATAR OS ERROS
  private handleErrors(error: Response) {
    console.log("SALVANDO O ERRO: ", error);
    return Observable.throw(error);
  }
}



// WEBPACK FOOTER //
// C:/xampp2/htdocs/angular-front/src/app/shared/auth.service.ts